import AlertBox from '@shared/components/AlertBox.tsx';

const AccommodationToEarlyBookingError = () => {
    return (
        <div className='mb-4'>
            <AlertBox
                theme='warning'
                heading='Det gick inte att skapa en bokning'
            >
                <p>Bokningar via webben behöver göras minst 30 dagar i förväg. </p>
                <p>
                    Om du önskar boka med kortare varsel är du varmt välkommen att kontakta oss via telefon på:{' '}
                    <a
                        href='tel:010-480 30 00'
                        className='text-nowrap'
                    >
                        010-480 30 00
                    </a>
                    .
                </p>
            </AlertBox>
        </div>
    );
};
export default AccommodationToEarlyBookingError;
